function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTeamViewer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 26 26"
}, props), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TeamViewer_svg__a",
  x1: 12.999,
  x2: 12.999,
  y1: 3.614,
  y2: 22.339,
  gradientTransform: "matrix(1 0 0 -1 .001 26)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#096fd2"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#0e8ee9"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "M20.4 3.7H5.6c-1.1 0-1.9.9-1.9 1.9v14.8c0 1.1.9 1.9 1.9 1.9h14.8c1.1 0 1.9-.9 1.9-1.9V5.6c0-1.1-.8-1.9-1.9-1.9m-7.4 17c-4.3 0-7.7-3.5-7.7-7.7S8.7 5.3 13 5.3s7.7 3.5 7.7 7.7-3.4 7.7-7.7 7.7",
  style: {
    fill: "url(#TeamViewer_svg__a)"
  }
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "TeamViewer_svg__b",
  x1: 12.994,
  x2: 12.992,
  y1: 10.524,
  y2: 15.474,
  gradientTransform: "matrix(1 0 0 -1 .001 26)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#096fd2"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#0e8ee9"
  }
})), /*#__PURE__*/React.createElement("path", {
  d: "m20.1 13-5.4-2.5.4 1.6h-4.5l.4-1.6L5.8 13l5.4 2.5-.4-1.6h4.5l-.4 1.6z",
  style: {
    fill: "url(#TeamViewer_svg__b)"
  }
}));
export default SvgTeamViewer;